import styled from 'styled-components';

export const Container = styled.div`
  will-change: transition;
  height: auto;
  background: ${p => p.theme.colors.white};
  width: 100%;
  overflow: inherit;
  transition: box-shadow 0.3s;
  position: relative;
`;
